<div class="mt-4">
  <nav id="pagination" aria-label="Page navigation example">
    <ul class="pagination mb-5">
      <li class="page-item" [ngClass]="{disabled: paginaActual === 1}">
        <button class="page-link pointer" (click)="selectPage(paginaActual - 1)" aria-label="Previous"
          [disabled]="paginaActual === 1">
          <span aria-hidden="true">&laquo;</span>
        </button>
      </li>
      @for (page of pages(); track page; let i = $index) {
        <li class="page-item"
          [ngClass]="{active : page === paginaActual}">
          <a class="page-link pointer" (click)="selectPage(page, i)">
            {{ page }}
          </a>
        </li>
      }
      <li class="page-item" [ngClass]="{disabled: totalPaginas === paginaActual || totalPaginas === 1}">
        <button class="page-link pointer" (click)="selectPage(paginaActual + 1)"
          [disabled]="totalPaginas === paginaActual || totalPaginas === 1" aria-label="Next">
          <span aria-hidden="true">&raquo;</span>
        </button>
      </li>
      <input class="ms-3 me-1 col-1 form-control" type="number" placeholder="#" min="1" (keyup)="validatePage()"
        oncopy="return false" onpaste="return false" [max]="totalPaginas" [(ngModel)]="selectedPage"
        style="width: auto !important">
        <button [disabled]="!isPage" class="btn btn-primary hvr-grow" (click)="selectPage(selectedPage)">Ir
        a</button>
      </ul>
    </nav>
  </div>